// 이미지 경로 설정

export default {
  imgPath: {
    teamLogo: 'https://s3.ap-northeast-2.amazonaws.com/crm.thesports.io/img/common/emblem/', // 팀 로고 이미지 경로
    couponIcon: 'https://gnfc-upload-file.s3.ap-northeast-2.amazonaws.com/' // 쿠폰 아이콘 이미지 경로
  },
  setTeamLogo: function (num) {
    return `${this.imgPath.teamLogo}${num}.png`
  },
  setCouponIcon: function (name) {
    return `${this.imgPath.couponIcon}${name}.svg`
  }
}
